import { useEffect, useRef } from 'react';

import { ApplicationState } from '@/store';
import { checkIfDataIsLoadedForContactsList } from '@/store/contacts/actions';
import { useSelector } from 'react-redux';
import { useContactQueryParams } from './useContactQueryParams';
import { useEntityRuleForFiltration } from './useFiltrationRule';

export const useContactsPagination = () => {
    const { querySearch, queryOrderBy, queryStatuses, queryPerPage, pushParamToUrl, listname, segmentname } =
        useContactQueryParams();
    const { entityRule } = useEntityRuleForFiltration();
    const { isDataLoaded } = useSelector((store: ApplicationState) =>
        checkIfDataIsLoadedForContactsList(store, listname || segmentname)
    );
    const initRender = useRef(true);
    //handle pagination change after some of the params are changed, but prevent to fallback to 1st page on init render.
    useEffect(() => {
        if (!isDataLoaded || initRender.current) {
            initRender.current = false;
            return;
        }

        pushParamToUrl({ page: null });
    }, [queryStatuses?.toString(), querySearch, entityRule, queryPerPage, queryOrderBy]);
};
